import { defineComponent as _defineComponent } from 'vue'
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import WidgetContainer from '@/components/Charts/widgetContainer/WidgetContainer.vue';
import DateGroupingFilter from '@/components/DateGroupingFilter.vue';
import { dateRangeToDateStrings, yearToDate } from '@/utils/dates';
import LayoutGrid from '../dashboard/LayoutGrid.vue';
import {
  availableDashboardLayouts,
  DashboardLayout,
} from '@/models/Charts/dashboardDefinition';
import { computed, ref } from 'vue';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Overview',
  setup(__props) {

const { t } = useI18n();

const gridLayout = availableDashboardLayouts[DashboardLayout.BCOverviewLike];

const datepickerRef = ref<any>();
const selectedAxisTimespan = ref<FilterTimeAxisSpanEnum>(
  FilterTimeAxisSpanEnum.Month,
);
const dateRangeSelection = ref<[Date, Date]>(yearToDate());

function toggleDatepicker() {
  datepickerRef.value?.toggle();
}

const widgetDefinitions = computed<WidgetDefinition[]>(() =>
  [
    openSalesFunnelWidgetDefinition.value,
    businessOverviewFiguresWidgetDefinition.value,
    salesMapWidgetDefinition.value,
  ].map((wd, index) => wd.withIndex(index)),
);

const openSalesFunnelWidgetDefinition = computed<WidgetDefinition>(
  () =>
    new WidgetDefinition(
      WidgetEnum.OpenSalesFunnel,
      [],
      dateRangeString.value,
      [],
      undefined,
      selectedAxisTimespan.value,
    ),
);

const businessOverviewFiguresWidgetDefinition = computed<WidgetDefinition>(
  () =>
    new WidgetDefinition(
      WidgetEnum.BusinessOverviewFigures,
      [],
      dateRangeString.value,
      [],
    ),
);

const salesMapWidgetDefinition = computed<WidgetDefinition>(
  () =>
    new WidgetDefinition(WidgetEnum.SalesMap, [], dateRangeString.value, []),
);

const dateRangeString = computed<[string, string]>(() =>
  dateRangeToDateStrings(dateRangeSelection.value),
);

return { __sfc: true,t, gridLayout, datepickerRef, selectedAxisTimespan, dateRangeSelection, toggleDatepicker, widgetDefinitions, openSalesFunnelWidgetDefinition, businessOverviewFiguresWidgetDefinition, salesMapWidgetDefinition, dateRangeString, WidgetContainer, DateGroupingFilter, LayoutGrid }
}

})